import styled from "@emotion/styled"

export const ContactFormWrapper = styled.form(({theme}) => ({
    position: 'relative',
    background: theme.colors.N30,
    borderRadius: 12,
    padding: 32,
    "& h3": {
        marginBottom: 32,
    },
    "& label": {
        fontWeight: theme.fontWeights.medium,
        marginTop: 0,
        [theme.breakpoint.down("md")]: {
            lineHeight: 1.43,
            fontSize: theme.fonts.pxToRem(14),
        },
    },
    "& button": {
        marginTop: 16,
        height: 56,
    },
    [theme.breakpoint.down("md")]: {
        padding: 16,
        '& h3': {
            marginBottom: 8
        }
    },

    '& .reset': {
        position: 'absolute',
        top: 2,
        left: 50,
        color: '#297AFF',
        cursor: 'pointer',
        '&:hover': {
            textDecoration: 'underline'
        }
    }
}))

export const Row = styled.div(({theme}) => ({
    width: "100%",
    display: "flex",
    justifyContent: "space-between",
    flexWrap: "wrap",
    marginBottom: 16,
}))

export const Column = styled.div(({theme}) => ({
    position: 'relative',
    width: "calc(50% - 12px)",
    [theme.breakpoint.down("md")]: {
        width: "100%",
        marginBottom: 16,
    },
}))

export const LabelWrapper = styled.div(({theme}) => ({
    position: 'absolute',
    top: 32,
    right: 32,

    [theme.breakpoint.down("md")]: {
        position: 'relative',
        top: 'auto',
        right: 'auto',
        marginBottom: 16,
    }
}))